import { render } from "./CashflowLabel.vue?vue&type=template&id=21970b13&scoped=true"
import script from "./CashflowLabel.vue?vue&type=script&lang=js"
export * from "./CashflowLabel.vue?vue&type=script&lang=js"

import "./CashflowLabel.vue?vue&type=style&index=0&id=21970b13&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21970b13"],['__file',"src/components/CashflowLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21970b13"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21970b13', __exports__)) {
    api.reload('21970b13', __exports__)
  }
  
  module.hot.accept("./CashflowLabel.vue?vue&type=template&id=21970b13&scoped=true", () => {
    api.rerender('21970b13', render)
  })

}


export default __exports__